import React, {useContext, useEffect, useRef} from 'react';
import {useNavigate} from 'react-router-dom';
import Transition from '../../../mosaic/utils/Transition.jsx';
import {useTranslation} from "react-i18next";
import Spinner from "../../Spinner.jsx";
import UserDropdownProjectList from "./UserDropdownProjectList.jsx";
import {GlobalContext} from "../../../utils/context/GlobalContextProvider.jsx";
import IdentityImage from "../../IdentityImage.jsx";
import {useProjectRoutes} from "../../../Routing.jsx";


function DropdownProfile({align}) {

    const {t} = useTranslation();

    const trigger = useRef(null);
    const dropdown = useRef(null);

    let {context, setUserDropdownOpened, setCurrentIdentity} = useContext(GlobalContext);

    let navigate = useNavigate();

    // close on click outside
    useEffect(() => {
        const clickHandler = ({target}) => {
            if (!dropdown.current) return;
            if (!context.userDropdownOpened || dropdown.current.contains(target) || trigger.current.contains(target)) return;
            setUserDropdownOpened(false);
        };
        document.addEventListener('click', clickHandler);
        return () => document.removeEventListener('click', clickHandler);
    });

    // close if the esc key is pressed
    useEffect(() => {
        const keyHandler = ({keyCode}) => {
            if (!context.userDropdownOpened || keyCode !== 27) return;
            setUserDropdownOpened(false);
        };
        document.addEventListener('keydown', keyHandler);
        return () => document.removeEventListener('keydown', keyHandler);
    });

    let currentProject = null;
    for (let project of context.currentUserProjects) {
        // noinspection JSUnresolvedReference
        if (project.id === context.currentProjectId) {
            // noinspection JSUnresolvedReference
            currentProject = project;
        }
    }

    if (context.currentIdentity === null || currentProject === null) {
        return <Spinner/>
    }

    return (
        <div className="relative inline-flex">
            <button
                ref={trigger}
                className="inline-flex justify-center items-center group"
                aria-haspopup="true"
                onClick={() => setUserDropdownOpened(!context.userDropdownOpened)}
                aria-expanded={context.userDropdownOpened}
            >
                <IdentityImage
                    url={context.currentIdentity.user.avatarUrl}
                    url2={currentProject.logoUrl}
                    project={currentProject}
                    user={context.currentIdentity.user}
                />
                <div className="flex items-center truncate">
                    <div className="flex flex-col justify-start text-left">
                        <div
                            className="font-bold truncate mx-2 text-sm dark:text-slate-300 group-hover:text-slate-800 dark:group-hover:text-slate-200">
                            {context.currentIdentity.user.firstName}
                            &nbsp;
                            {context.currentIdentity.user.lastName}
                        </div>
                        <div className="font-normal truncate mx-2 text-xs -mt-1 text-violet-500 hover:text-violet-400 dark:text-violet-400 dark:hover:text-violet-300">
                            {currentProject.name}
                        </div>
                    </div>
                    <svg className="w-3 h-3 shrink-0 ml-1 fill-current text-slate-400" viewBox="0 0 12 12">
                        <path d="M5.9 11.4L.5 6l1.4-1.4 4 4 4-4L11.3 6z"/>
                    </svg>
                </div>
            </button>

            <Transition
                className={`origin-top-right z-60 absolute top-full min-w-[200px] bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded shadow-lg overflow-hidden mt-1.5 ${align === 'right' ? 'right-0' : 'left-0'}`}
                show={context.userDropdownOpened}
                enter="transition ease-out duration-200 transform"
                enterStart="opacity-0 -translate-y-2"
                enterEnd="opacity-100 translate-y-0"
                leave="transition ease-out duration-200"
                leaveStart="opacity-100"
                leaveEnd="opacity-0"
            >
                <div
                    ref={dropdown}
                    onFocus={() => setUserDropdownOpened(true)}
                    onBlur={() => setUserDropdownOpened(false)}
                >

                    <UserDropdownProjectList/>

                    <div className="py-2">
                        <ul>
                            <li>
                                <div
                                    className="font-medium text-sm flex items-center py-1 px-3 cursor-pointer"
                                >
                                    {context.currentIdentity.user.email}
                                </div>
                            </li>
                            <li>
                            <span
                                className="text-violet-500 hover:text-violet-400 dark:text-violet-400 dark:hover:text-violet-300 font-medium text-sm flex items-center py-1 px-3 cursor-pointer"
                                onClick={() => {
                                    setUserDropdownOpened(false);
                                    navigate('/settings/profile');
                                }}
                            >
                                {t('user.account-settings')}
                            </span>
                            </li>
                            <li>
                            <span
                                className="text-violet-500 hover:text-violet-400 dark:text-violet-400 dark:hover:text-violet-300 font-medium text-sm flex items-center py-1 px-3 cursor-pointer"
                                onClick={() => {
                                    // noinspection JSUnresolvedReference
                                    // window.FB.logout();
                                    setCurrentIdentity(null);
                                    navigate('/sign/in');
                                }}
                            >
                                {t('auth.sign-out')}
                            </span>
                            </li>
                        </ul>
                    </div>
                </div>
            </Transition>
        </div>
    );
}

export default DropdownProfile;